import React, {Component} from 'react';
import withRouter from "react-router/es/withRouter";
import connect from "react-redux/es/connect/connect";
import {REQUEST_FACILITIES_META_DATA} from "../../actions/facilitiesMetaActions";
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import Skeleton from "../Skeleton/Skeleton";
import FacilityCard from "../FacilityCard/FacilityCard";

const mapStateToProps = (state) => {
    return {
        rawFacilities: state.facilitiesData.rawFacilities,
        facilitiesMeta: state.facilitiesMetaData
    }
};

const mapDispatchToProps = dispatch => ({
    getFacilitiesMeta: () => dispatch({type: REQUEST_FACILITIES_META_DATA}),
    getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA})
});

class FacilityAccordion extends Component {

    state = {
        template: <Skeleton type="IFRAME"/>
    };

    componentDidMount() {
        this.checkData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isAllOpen !== prevProps.isAllOpen) {
            if (this.props.isAllOpen) {
                this.setState({
                    template: this.getExpandedTemplate()
                })
            } else {
                this.setState({
                    template: this.getTemplate()
                });
            }
        }
    }

    checkData() {
        if (this.props.rawFacilities && this.props.contacts) {
            this.setState({
                template: this.getTemplate()
            });
        } else {
            this.setState({
                template: this.props.errorTemplate || <Skeleton type="IFRAME_ERROR"/>
            });
        }
    }

    group(items, key) {
        const unique = [
            ...new Set(items.map(item => item["facilityInfo"]["location"][key]))
        ]
        unique.sort();

        const sortFn = (a, b) => a.facilityInfo.location.stateName > b.facilityInfo.location.stateName ? 1 : -1;

        const sortedItems = (val) => {
            let sorted = items.filter(item => item["facilityInfo"]["location"][key] === val);
            sorted.sort(sortFn);
            return sorted;
        }
        return unique.reduce((map, cur) => map.set(cur, sortedItems(cur)), new Map());
    }

    convertStateAbbrevToStateName(stateAbbrev) {
        let state = this.props.facilitiesMeta.states.find(state => {
            return state.stateAbrev === stateAbbrev;
        });

        if (state && state.stateName) {
            return state.stateName;
        }

        return stateAbbrev;
    };

    getTemplate(selectedKey) {
        const sortedByStateFacilities = this.group(this.props.rawFacilities, "stateName");
        return this.getSimpleTemplate(selectedKey, sortedByStateFacilities);
    }

    getSimpleTemplate(selectedKey, sortedAccordionData) {
        if (sortedAccordionData) {
            return Array.from(sortedAccordionData).map(([state, item]) => (
                    <ExpansionPanel
                            key={state + "Panel"}
                            className="accordion__header-container"
                            expanded={state === selectedKey}
                            onChange={event => this.handlePanelExpansion(event, state)}
                    >
                        <ExpansionPanelSummary
                                className="accordion__header"
                                expandIcon={<ExpandMoreIcon className="accordion__expand-icon"/>}>
                            <div className="accordion__title">{state === "" ? "International" : this.convertStateAbbrevToStateName(state)}</div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="accordion__content">
                            <FacilityCard facilities={item} contacts={this.props.contacts}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
            ));
        }
        return null;
    }

    getExpandedTemplate = () => {
        const sortedAccordionData = this.group(this.props.rawFacilities, "stateName");
        if (sortedAccordionData) {
            return Array.from(sortedAccordionData).map(([state, item]) => (
                    <ExpansionPanel
                            key={state + "Panel"}
                            className="accordion__header-container"
                            expanded={true}
                            onChange={event => this.handlePanelExpansion(event, state)}
                    >
                        <ExpansionPanelSummary
                                className="accordion__header"
                                expandIcon={<ExpandMoreIcon className="accordion__expand-icon"/>}>
                            <div className="accordion__title">{state === "" ? "International" : this.convertStateAbbrevToStateName(state)}</div>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="accordion__content">
                            <FacilityCard facilities={item} contacts={this.props.contacts}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
            ));
        }
        return null;
    }

    handlePanelExpansion(event, key) {
        this.key = key === this.key ? null : key;
        this.setState({
            template: this.getTemplate(this.key, this.props.rawFacilities)
        });
    }

    render() {
        return this.state.template
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilityAccordion));



// WEBPACK FOOTER //
// ./src/components/FacilityAccordion/FacilityAccordion.js